import VueI18n from '../libs/i18n/index';
import { SERVER_AI_ERROR_CODE } from "../enum/enum-server-ai-error-code";
import { SYSTEM_SERVER_ERROR_CODE } from "../enum/enum-system-server-error-code";

class SystemServerErrorHelper {
    getTranslateSystemServerErrorText(code) {
        const key = Object.keys(SYSTEM_SERVER_ERROR_CODE).find(item => SYSTEM_SERVER_ERROR_CODE[item].code == code);
        if (key) {
            return VueI18n.t('SYSTEM_SERVER_ERROR')[SYSTEM_SERVER_ERROR_CODE[key].i18n];
        }
        return '';
    }
    getTranslateServerAiError(code) {
        const key = Object.keys(SERVER_AI_ERROR_CODE).find(item => SERVER_AI_ERROR_CODE[item].code == code);
        if (key) {
            return VueI18n.t('SERVER_AI_ERROR')[SERVER_AI_ERROR_CODE[key].i18n];
        }
        return '';
    }
  
}

export default new SystemServerErrorHelper();
